import { render, staticRenderFns } from "./AssetsSelect.vue?vue&type=template&id=1d455a6f"
import script from "./AssetsSelect.vue?vue&type=script&lang=js"
export * from "./AssetsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports